//====================================================
//  Function: Category
//====================================================
function componentCategory() {
  if ($(".type-category").length) {
    // $(".zapati").append("<div>init</div>");
    $(".pagination-loader .load-products").text(loadMore);
    // setTimeout(() => {
    createSort();
    sidebarInit();
    componentTopBanner();
    componentProduct();
    // }, 1500);
  }

  document.addEventListener("ShoptetPagePaginationUsed", function () {
    // $(".zapati").append("<div>ShoptetPagePaginationUsed</div>");
    // console.log("<div>ShoptetPagePaginationUsed</div>");
    recallProductList();
  });

  document.addEventListener("ShoptetPageSortingChanged", function () {
    // $(".zapati").append("<div>ShoptetPageSortingChanged</div>");
    // console.log("<div>ShoptetPageSortingChanged</div>");
    recallProductList();
  });

  document.addEventListener("ShoptetPagePriceFilterChange", function () {
    // $(".zapati").append("<div>ShoptetPagePriceFilterChange</div>");
    // console.log("<div>ShoptetPagePriceFilterChange</div>");
    recallProductList();
  });

  document.addEventListener("ShoptetPageFilterValueChange", function () {
    // $(".zapati").append("<div>ShoptetPageFilterValueChange</div>");
    // console.log("<div>ShoptetPageFilterValueChange</div>");
    recallProductList();
  });

  document.addEventListener("ShoptetPageFiltersCleared", function () {
    // $(".zapati").append("<div>ShoptetPageFiltersCleared</div>");
    // console.log("<div>ShoptetPageFiltersCleared</div>");
    recallProductList();
  });

  shoptet.scripts.setCustomCallback("shoptet.cart.updateCartButton", function (
    args
  ) {
    // console.log("Asd");
    // $(".zapati").append("<div>shoptet.cart.updateCartButton</div>");
    // console.log(".cart.updateCartButton</div>");
  });

  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    // $(".zapati").append("<div>ShoptetDOMCartContentLoaded</div>");
    // console.log("<div>ShoptetDOMCartContentLoaded</div>");
  });

  document.addEventListener("ShoptetPageMoreProductsRequested", function () {
    // console.log("ShoptetPageMoreProductsRequested1");
    setTimeout(() => {
      // $(".zapati").append("<div>ShoptetPageMoreProductsRequested</div>");
      // console.log("<div>ShoptetPageMoreProductsRequested</div>");
      $(".pagination-loader .load-products").text(loadMore);
      componentProduct();
      sidebarInit();
      // console.log("ShoptetPageMoreProductsRequested2");
      // recallProductList();
    }, 1500);
  });
}

function recallProductList() {
  setTimeout(() => {
    // $(".zapati").append("<div> recalProductList</div>");
    // console.log("<div> recalProductList</div>");
    // alert("recalProductlist")
    $(".pagination-loader .load-products").text(loadMore);
    $(".type-category .category-perex").insertAfter(".type-category h1");
    createSort();
    componentProduct();
    sidebarTitle();
    sidebarInit();
    componentSaleBanner();
    componentTopBanner();
  }, 1500);
}

function createSort() {
  if ($(".sort-header").length == 0) {
    var sortDropdown = `
				<div class="sort-header">
					<div class="sort-title">
						<svg class="icon-svg icon-filter">
								<use xlink:href="https://www.365121.myshoptet.${lang}/user/documents/public/images/sprites.svg#icon-filter"></use>
						</svg>
						<div class="sort-title-text">${categorySort} <strong class="js-sort-title"></strong></div>
					</div>
				</div>
			`;
    $(".category-header").wrap(sortDropdown);
    var label = $(".category-header form input[checked]").next().text();
    $(".js-sort-title").text(label);
  }
}

function createSizeTreeTags() {
  var sidebarSize = $(".sidebar-velikost").closest(".filter-section").clone();
  sidebarSize.insertAfter($(".sort-header"));
}

function createTypeTreeTags() {
  var sidebarSizeType = $(".sidebar-jehlici")
    .closest(".filter-section")
    .clone();
  sidebarSizeType.insertAfter($(".sort-header"));
}

function sidebarInit() {
  if ($(".filters-unveil-button-wrapper").length == 0) {
    $("#filters")
      .addClass("filters")
      .wrap('<div class="filters-wrapper"></div>');
    $(".filters-wrapper").prepend(
      '<div class="filters-unveil-button-wrapper"><a href="#" class="btn btn-default unveil-button" data-unveil="filters" data-text="' +
        categoryClose +
        ' filter">' +
        categoryOpen +
        " filter</a></div>"
    );

    $(document).on("click", ".filters-unveil-button-wrapper", function () {
      // $("#filters").toggleClass("visible");
      // $("body").toggleClass("filters-visible");
      // $(".category-filter-hover").removeClass("visible");
    });
  }

  if ($("#category-filter-hover").length == 0) {
    $(".filter-sections").wrapInner('<div id="category-filter-hover"></div>');
  }

  if ($(".filter-section-count").length == 0) {
    $("#category-filter-hover").append(
      '<div class="filter-section filter-section-count"></div>'
    );
  }

  $("#clear-filters a").text(categoryRemove);

  if ($(".sidebar .price-group").length == 0) {
    $(".slider-wrapper, #price-filter-form").wrapAll(
      '<div class="price-group"></div>'
    );
    $(".price-group").insertBefore($("#filters .filter-section-count"));
  }

  if ($(".content .sidebar-velikost").length == 0) {
    if ($(".sidebar-velikost").length) {
      createSizeTreeTags();
    }
  }

  if ($(".content .sidebar-jehlici").length == 0) {
    if ($(".sidebar-jehlici").length) {
      if (
        $('.category-title:contains("Podľa druhu ihličia")').length ||
        $('.category-title:contains("Podle druhu jehel")').length ||
        $('.category-title:contains("Podle druhů jehel")').length
      ) {
        createTypeTreeTags();
      }
    }
  }

  if ($(".content .sidebar-farba").length == 0) {
    if ($(".sidebar-farba").length) {
      var sidebarSection = $(".sidebar-farba")
        .closest(".filter-section")
        .addClass("filter-section-color");

      sidebarSection.insertBefore($("#filters .filter-section-count"));

      // $(".filters-wrapper .btn-default unveil-button").text("PODROBNÝ FILTER");
    }
  }

  if (
    $(".content #filters").length &&
    $(".content-filter-header").length == 0
  ) {
    $('<div class="content-filter-header"></div').insertBefore(
      $(".content #category-filter-hover")
    );

    // <div class="filter-header-mobile__icon js-toggle-filter">
    // 	<svg class="icon-svg icon-close">
    // 		<use xlink:href="https://www.365121.myshoptet.${lang}/user/documents/public/images/sprites.svg#icon-close"></use>
    // 	</svg>
    // </div>
    var filterMobileHeader = `
			<div class="filter-header-mobile">
				<div class="filter-header-mobile__text">${categoryMore}</div>
			</div>
		`;

    $(".content-filter-header").append(filterMobileHeader);

    // var submitFilter = `
    // <div class="btn-filter-block">
    // 	<button class="btn btn--responsive btn--blue-fill js-toggle-filter btn-filter">
    // 		<svg class="icon-svg icon-filter-white">
    // 			<use xlink:href="https://www.365121.myshoptet.${lang}/user/documents/public/images/sprites.svg#icon-filter-white"></use>
    // 		</svg>
    // 		${categoryUsed}
    // 	</button></div>
    // `;
    // $(submitFilter).insertBefore(
    //   $(".content #category-filter-hover .filter-section-count")
    // );
  }

  //   $(".content-filter-header").load(
  //     "/ .sidebar .box-categories",
  //     function () {}
  //   );
  // }
}

function sidebarTitle() {
  $(".sidebar-left h4:contains('Kategórie')")
    .addClass("sidebar-ponuka")
    .text(categoryTitle);
  $(".sidebar-left h4:contains('Typ ihličia')").addClass("sidebar-jehlici");
  $(".sidebar-left h4:contains('Typ jehel')").addClass("sidebar-jehlici");
  $(".sidebar-left h4:contains('Typ stromčeka')").addClass("sidebar-strom");
  $(".sidebar-left h4:contains('Typ stromu')").addClass("sidebar-strom");
  $(".sidebar-left h4:contains('Veľkosť stromčeka')").addClass(
    "sidebar-velikost"
  );
  $(".sidebar-left h4:contains('Velikost stromu')").addClass(
    "sidebar-velikost"
  );
  $(".sidebar-left h4:contains('Farba')").addClass("sidebar-farba");
  $(".sidebar-left h4:contains('Barva')").addClass("sidebar-farba");

  $(".mobile .filter-sections h4:contains('Kategórie')")
    .addClass("sidebar-ponuka")
    .text(categoryTitle);
  $(".mobile .filter-sections h4:contains('Kategorie')")
    .addClass("sidebar-ponuka")
    .text(categoryTitle);
  $(".mobile .filter-sections h4:contains('Typ ihličia')").addClass(
    "sidebar-jehlici"
  );
  $(".mobile .filter-sections h4:contains('Typ jehel')").addClass(
    "sidebar-jehlici"
  );
  $(".mobile .filter-sections h4:contains('Typ stromčeka')").addClass(
    "sidebar-strom"
  );
  $(".mobile .filter-sections h4:contains('Typ stromu')").addClass(
    "sidebar-strom"
  );
  $(".mobile .filter-sections h4:contains('Veľkosť stromčeka')").addClass(
    "sidebar-velikost"
  );
  $(".mobile .filter-sections h4:contains('Veľkosť stromečku')").addClass(
    "sidebar-velikost"
  );
  $(".mobile .filter-sections h4:contains('Farba')").addClass("sidebar-farba");
  $(".mobile .filter-sections h4:contains('Barva')").addClass("sidebar-farba");
}

$(document).on("click", ".js-toggle-filter", function () {
  $(".filters-wrapper .unveil-button").trigger("click");
  // $(".category-filter-hover").removeClass("visible");
});
